import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import styles from '../../../styles/icons/base.module.scss';

const propTypes = {
    volume: PropTypes.number, // from 0 - 1
    fill: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    volume: 1,
    fill: 'currentColor',
    className: null,
};

const SoundIcon = ({ volume, fill, className }) => (
    <svg
        width="28"
        height="30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ opacity: volume === 0 ? 0.5 : 1 }}
        className={classNames([styles.container, { [className]: className !== null }])}
    >
        <mask id="a" fill={fill}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.927 21.666a2 2 0 0 0-1.401-.572H2.223a2 2 0 0 1-2-2v-7.648a2 2 0 0 1 2-2h5.754a2 2 0 0 0 1.4-.573l4.917-4.825c1.265-1.241 3.4-.345 3.4 1.428v19.05c0 1.772-2.135 2.669-3.4 1.427l-4.367-4.287Z"
            />
        </mask>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.927 21.666a2 2 0 0 0-1.401-.572H2.223a2 2 0 0 1-2-2v-7.648a2 2 0 0 1 2-2h5.754a2 2 0 0 0 1.4-.573l4.917-4.825c1.265-1.241 3.4-.345 3.4 1.428v19.05c0 1.772-2.135 2.669-3.4 1.427l-4.367-4.287Z"
            fill={fill}
        />
        <path
            d="m14.294 25.953.7-.714-.7.714ZM9.378 8.873l-.7-.713.7.713Zm.549 12.793-.7.714.7-.713Zm-1.401-1.572H2.223v2h6.303v-2Zm-7.303-1v-7.648h-2v7.648h2Zm1-8.648h5.754v-2H2.223v2Zm7.855-.859 4.916-4.825-1.4-1.427L8.676 8.16l1.401 1.427Zm6.617-4.111v19.05h2V5.476h-2Zm-1.7 19.763-4.368-4.286-1.401 1.427 4.367 4.287 1.401-1.428Zm1.7-.713c0 .886-1.068 1.334-1.7.713l-1.402 1.427c1.898 1.863 5.102.519 5.102-2.14h-2Zm-1.7-19.764c.632-.62 1.7-.173 1.7.714h2c0-2.66-3.204-4.004-5.102-2.141l1.401 1.427Zm-7.018 5.684a3 3 0 0 0 2.101-.859l-1.4-1.427a1 1 0 0 1-.701.286v2Zm-6.754 1a1 1 0 0 1 1-1v-2a3 3 0 0 0-3 3h2Zm1 8.648a1 1 0 0 1-1-1h-2a3 3 0 0 0 3 3v-2Zm6.303 2a1 1 0 0 1 .7.286l1.401-1.427a3 3 0 0 0-2.101-.86v2Z"
            fill={fill}
            mask="url(#a)"
        />
        {volume > 0 && volume <= 1 ? (
            <path
                d="M19.636 19.152a3.883 3.883 0 0 0 0-7.765"
                // stroke="#171717"
                stroke={fill}
                strokeLinecap="round"
            />
        ) : null}
        {volume === 1 ? (
            <path
                d="M19.636 23.035a7.765 7.765 0 1 0 0-15.53"
                // stroke="#171717"
                stroke={fill}
                strokeLinecap="round"
            />
        ) : null}
    </svg>
);

SoundIcon.propTypes = propTypes;
SoundIcon.defaultProps = defaultProps;

export default SoundIcon;
